import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { getBalance, estimateFeesPerGas, prepareTransactionRequest, sendTransaction, signMessage, waitForTransactionReceipt, getConnectors, getAccount, connect } from '@wagmi/core';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, firstValueFrom, forkJoin } from 'rxjs';
import { IdleService } from 'src/app/core/services/idle.service';
import { environment } from 'src/environments/environment';
import { getAddress, parseEther } from 'viem';
import { INTERNAL_JSON_RPC_ERROR } from '../constants/errors.const';
import { MethodTypes } from '../utils/common.interface';
import { AccountService } from './account.service';
import { TransactionService } from './transaction.service';
import { WebStorageService } from './web-storage.service';
import { wagmi_config } from '../utils/wagmi-config';
const imageFileExtension = ['png', 'jpeg', 'jpg', 'webp', 'gif', 'svg', 'tiff', 'ico', 'heif', 'heic'];
const documentFileExtension = ['doc', 'docx', 'odt', 'rtf', 'txt', 'csv', 'pdf'];
const mediaFileExtension = ['webm', 'avif', 'mp4', 'mov', 'ogg', 'wmv'];
const fileSizeLimits = {
    IMAGE: 15, // 10MB
    VIDEO: 500, // 500MB
    FILE: 20, // 20MB
    AUDIO: 100, // 100MB //We are not allowed this
};
@Injectable({
    providedIn: 'root'
})
export class CommonService {

    private showGridView = new BehaviorSubject(true);
    public showGridViewObservable = this.showGridView.asObservable();

    private signinPageHeader = new BehaviorSubject(false);
    public siginpageObservable = this.signinPageHeader.asObservable();

    private showoverlay = new BehaviorSubject(false);
    showmodaloverlayObservable = this.showoverlay.asObservable();

    private closeModals = new BehaviorSubject(false);
    closeModalsObservable = this.closeModals.asObservable();

    private tabEmitter: any;
    tabEmitterObserve!: Observable<{ type: string }>;

    private transactionProvider = new BehaviorSubject({});
    public transactionListener: Observable<any> = this.transactionProvider.asObservable();

    private custodialType = new BehaviorSubject('');
    public custodialTypeObservable = this.custodialType.asObservable();
    public docUrls: any;

    constructor(
        private http: HttpClient,
        private toastr: ToastrService,
        private webStorageService: WebStorageService,
        private transactionService: TransactionService,
        private router: Router,
        private accountService: AccountService,
        private idleService: IdleService,

    ) {
        this.tabEmitter = new BehaviorSubject({});
        this.tabEmitterObserve = this.tabEmitter.asObservable();
    }

    setTabEmitter(data: { type: string }) {
        this.tabEmitter.next(data);
    }
    /**
     * overlay */
    public setOverlay(type: boolean) {
        this.showoverlay.next(type)
    }
    /**
     * set grid view / table view
     */
    public setView(type: boolean) {
        this.showGridView.next(type);
    }

    /**
     * set hider and header and footer
    */
    public setHeaderHide(type: boolean) {
        this.signinPageHeader?.next(type);
    }

    /**
     * Datas emit
     * @param data
     */
    public transactionEmitter(type: object) {
        this.transactionProvider.next(type);
    }


    /**
     * Emits the selected custodial type
     * @param type The selected custodial type
     */
    setCustodialType(type: string) {
        this.custodialType.next(type);
    }

    /**
     * Uploads image
     * @param network
     * @returns
     */
    public uploadImage(body: any) {
        return firstValueFrom(this.http.post(`${environment.FILE_UPLOAD}/file-upload/document`, body));
    }

    /**
     * Image extension type check
     * @param name 
     * @param [isDocUpload] if we upload docments related means need to pass as true or other wise we don't pass
     * @returns mime type validation 
     */
    public imageMimeTypeValidation(name: string, isDocUpload: boolean = false): Boolean {
        console.log(isDocUpload, "isDocUpload")
        let supportedFileExtension = isDocUpload ? [...documentFileExtension, ...imageFileExtension] : [...imageFileExtension, ...mediaFileExtension];
        var ext = name.substring(name.lastIndexOf('.') + 1);
        if (supportedFileExtension.includes(ext.toLowerCase())) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Handles file size validation
     * @param fileName 
     * @param fileType 
     * @param currentSize 
     * @param [uploadSize] 
     * @returns  
     */
    public handleFileSizeValidation(fileName: any, uploadSize: number = 0, isDocUpload: boolean = false) {
        var extension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase()
        let fileSize = 0
        let fileType: string = ''
        this.getFileSize(extension, (result: any) => {
            fileSize = result.fileSize
            fileType = result.fileType
        })
        const isValidFile = this.imageMimeTypeValidation(fileName, isDocUpload)
        const Min_File_Size = 10
        const fileInKb = uploadSize / 1024
        const fileInMb = fileSize * 1024 * 1024
        if (!isValidFile) return 'File not supported.'
        if (fileInKb <= Min_File_Size) return `"${fileName}" is smaller than ${Min_File_Size}KB.`
        if (uploadSize >= fileInMb) return `${fileType} "${fileName}" exceeds ${fileSize}MB.`

        return true

    }

    /**
     * Gets file size
     * @param fileType 
     */
    public getFileSize(fileType: any, callBack: (result: { fileSize: number, fileType: string }) => any) {
        let fileSize: any;
        let getFileType: string = ''
        switch (true) {
            case imageFileExtension.includes(fileType):
                fileSize = fileSizeLimits['IMAGE']
                getFileType = 'Image'
                break;
            case mediaFileExtension.includes(fileType):
                fileSize = fileSizeLimits['VIDEO']
                getFileType = 'Video'
                break;

            case documentFileExtension.includes(fileType):
                fileSize = fileSizeLimits['FILE']
                getFileType = 'File'
                break;
            default:
                fileSize = fileSizeLimits['FILE']
                getFileType = 'File'
                break;
        }

        callBack({
            fileSize,
            fileType: getFileType
        })
    }


    /**
     * Images provenance documents
     * @param name 
     * @returns true if provenance documents 
     */
    imageProvenanceDocuments(name: string): boolean {
        const ext = name.substring(name.lastIndexOf('.') + 1).toLowerCase();
        return documentFileExtension.includes(ext);
    }

    public getCurrencies() {
        return this.http.get(`${environment.API_BASE_URL_V3}/currencies`);
    }

    getNonce() {
        return firstValueFrom(this.http.get(`${environment.API_BASE_URL}/user/nonce`))
    }

    async sendTransaction(account: any, contractAddress: string, abi: any, requiredGas: any, args: any, txId?: string) {
        try {
            let regulated = JSON.parse(this.webStorageService.getLocalStorage('regulated') || 'true');
            let feeData = await estimateFeesPerGas(wagmi_config,);
            const params = {
                account: account.walletAddress,
                to: contractAddress,
                data: abi,
                chainId: account.networkId,
                gasPrice: Number(feeData.gasPrice) ? Number(feeData.gasPrice) * 2 : undefined,
                gas: Number(requiredGas) * 2,
                value: args.value ? regulated ? Number(parseEther(args.value.toString())) : parseEther(args.value.toString()) : 0
            };
            if (regulated) return this.sendTransactionRegulated(params, args, txId);
            else return this.sendTransactionUnregulated(params, account, txId);
        } catch (error) {
            throw error
        }
    }

    async sendTransactionRegulated(params: any, args: any, transanctionId?: string) {
        let user = JSON.parse(this.webStorageService.getLocalStorage('user') || '{}');
        params.accountId = user.fire_block_address;
        params.from = params.account;
        params.contractAddress = params.to;
        params.function = args.functionName;
        params.parameters = args.args;
        params.abi_type = args.abiType;
        params.transaction_id = transanctionId
        delete params.account;
        delete params.data;
        delete params.chainId;
        delete params.gasPrice;
        try {
            const result = await this.http.post(`${environment.API_BASE_URL}/user/contract-transaction`, params).toPromise();
            return result;
        } catch (error) {
            console.error('Error fetching data:', error);
            return Promise.reject(error)
        }
    }

    /**
     * Sends transaction unregulated
     * @param params 
     * @param account 
     * @param [transanctionId] 
     * @returns  
     */
    async sendTransactionUnregulated(params: any, account: any, transanctionId?: string) {
        try {
            let txData: { [key: string]: any } = {
                status: 0
            }

            //Check if the connector is connected or not.

            const config = await prepareTransactionRequest(wagmi_config, params);
            txData['data'] = config?.data ? config?.data : '' //Pass The meta data to the transaction log.
            await this.transactionService.createTransaction(txData, transanctionId);
            let hash = await sendTransaction(wagmi_config, config);
            delete txData['data'] // Delete the data key after geting the hash and update the hash.

            // NOTE: Updates the transaction with the transaction hash and sets the status to 'In Progress'
            txData['transaction_hash'] = hash
            await this.transactionService.createTransaction(txData, transanctionId);

            return await waitForTransactionReceipt(wagmi_config, { hash, confirmations: 1 });
        } catch (error: any) {
            // NOTE: The following if-else structure is implemented to handle specific error cases:
            // 1. If the error type is an INTERNAL JSON-RPC error, which often follows an IntegerOutOfRange error,
            //    we explicitly reject the Promise with this error, as it's part of a known issue sequence.
            // 2. For other types of errors, we throw the error to allow further error handling mechanisms to catch it.
            if (error.details === INTERNAL_JSON_RPC_ERROR) {
                return Promise.reject(new Error(error.details))
            }
            else {
                throw error
            }
        }
    }

    getNetwork = (chainId: string) => {
        let network;
        let key;
        let networkId;
        switch (chainId) {
            case '0x1':
            case '1':
                chainId = '0x1';
                networkId = 1;
                network = 'Ethereum Mainnet';
                key = 'ETH';
                break;
            case '0x5':
            case '5':
                chainId = '0x5';
                networkId = 5;
                network = 'Goerli Testnet';
                key = 'GoerliETH';
                break;
            case '0x13882':
            case '80002':
                chainId = '0x13882';
                networkId = 80002;
                network = 'Polygon Testnet';
                key = 'MATIC';
                break;
            case '0x89':
            case '137':
                chainId = '0x89';
                networkId = 137;
                network = 'Polygon Mainnet';
                key = 'MATIC';
                break;
            default:
                network = 'Unknown';
                break;
        }
        return { network, key, chainId, networkId };
    }

    async getNativeBalance(account: any) {
        return await getBalance(wagmi_config, {
            address: await getAddress(account.walletAddress),
            chainId: Number(account.networkId)
        });
    }

    async getTokenBalance(account: any, tokenAddress: any) {
        return await getBalance(wagmi_config, {
            address: await getAddress(account.walletAddress),
            chainId: Number(account.networkId),
            token: tokenAddress
        });
    }

    getMaticPrice(network: string) {
        return this.http.get(`${environment.COINGECKO_API}/price?ids=${network}&vs_currencies=USD&x_cg_demo_api_key=${environment.COINGECKO_API_KEY}`);
    }

    getTokenPrice(tokenAddress: any) {
        return firstValueFrom(this.http.get(`${environment.COINGECKO_API}/token_price/polygon-pos?contract_addresses=${tokenAddress}&vs_currencies=USD&x_cg_demo_api_key=${environment.COINGECKO_API_KEY}`));
    }

    /**
     * get token price from databse
     * @param {string} tokenId
     */
    getTokenPriceFromDb(tokenId: string) {
        return this.http.get(`${environment.API_BASE_URL}/user/digital-value?address=${tokenId}`);

    }

    /**
     * Gets usdprice
     * @param network
     * @returns
     */
    public getUSDPrice(network: string) {
        return this.http.get(`${environment.COINGECKO_API}?ids=${network}&vs_currencies=usd&x_cg_demo_api_key=${environment.COINGECKO_API_KEY}`);
    }

    async getImage(media: any) {
        return fetch(media)
            .then(response => {
                return response.blob().then(blob => {
                    return {
                        contentType: response.headers.get("Content-Type"),
                        raw: blob
                    }
                })
            })
            .catch(error => console.log('fetch image'))
    }

    public closeAllModals(close: boolean) {
        this.closeModals.next(close)
    }

    getGoldPrice() {
        return firstValueFrom(this.http.get(`${environment.API_BASE_URL}/user/get-gold-value`));
    }

    calculateGoldValue = async (size: string, markupFee: number, goldValue: number = 0) => {
        // Define the conversion factors
        const OUNCE_TO_GRAM = 31.1035;
        const TOLA_TO_GRAM = 11.66;
        const KILO_TO_GRAM = 1000;
        let OUNCE_TO_USD: number;
        if (goldValue > 0) OUNCE_TO_USD = goldValue;
        else {
            let marketprice: any = await this.getGoldPrice();
            OUNCE_TO_USD = marketprice.data.gold_value
        }

        if (size?.includes(environment.ONE_KILO_GRAM)) {
            const weightInGrams = 1 * KILO_TO_GRAM;
            const weightInOunces = weightInGrams / OUNCE_TO_GRAM;
            const valueInUSD = weightInOunces * OUNCE_TO_USD;
            const totalUSD = valueInUSD + (valueInUSD * markupFee) / 100;
            return { price: valueInUSD, priceWithFee: totalUSD };
        } else if (size?.includes(environment.TEN_TOLA_BAR)) {
            const weightInGrams = 10 * TOLA_TO_GRAM;
            const weightInOunces = weightInGrams / OUNCE_TO_GRAM;
            const valueInUSD = weightInOunces * OUNCE_TO_USD;
            const totalUSD = valueInUSD + (valueInUSD * markupFee) / 100;
            return { price: valueInUSD, priceWithFee: totalUSD };
        } else if (size?.includes(environment.ONE_OUNCE)) {
            const totalUSD = OUNCE_TO_USD + (OUNCE_TO_USD * markupFee) / 100;
            return { price: OUNCE_TO_USD, priceWithFee: totalUSD };
        } else return 0
    }

    /**
     * Calculates platinum
     * @param ounce 
     * @param weight 
     * @returns  
     */
    calculatePlatinum(ounce: any, weight: any) {
        const OUNCE_TO_GRAM = 31.1035;
        const perGramPrice = ounce / OUNCE_TO_GRAM
        return weight * perGramPrice
    }


    /**
     * get time remaining from current time
     */
    getTimeRemaining(endDate: string | Date): string {
        const end = new Date(endDate).getTime();
        const now = new Date().getTime();
        const timeDiff = end - now;

        if (timeDiff < 0) {
            return ''
        }

        const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));

        return `(in ${days} days, ${hours} hours, ${minutes} minutes).`;

    }

    calculateInterest(loanAmount: number, loanDuration: number, loanPercentage: number, chainId: any) {
        let divisor = (environment as any)[chainId].LOAN_IN_DAYS ? (365 * 100) : (365 * 24 * 100)
        let interest_amount = (loanAmount * loanDuration * loanPercentage) / divisor;
        let total_amount = Number(loanAmount) + Number(interest_amount);
        return { interest_amount, total_amount }
    }

    /**
     * Gets the appraisal value of an NFT.
     *
     * @param {any} nft - The NFT object containing details like category, lazy mint status, and sale details.
     * @returns {string | number} The appraisal value, which can be a number or a dash ('-') if the value is not available.
     */
    getAppraisalValue(nft: any): string | number {
        if (!nft) {
            return '-';
        }

        const isGoldCategory = nft.category === 'gold';
        const isLazyMint = isGoldCategory ? nft?.collections?.isLazyMint : nft?.lazy_mint

        const marketPrice = Math.ceil(nft?.marketPrice);
        if (isLazyMint) {
            const exchangePrice = Math.ceil(nft.sale_details?.exchange_price);
            const salePrice = Math.ceil(nft.sale_details?.price);

            if (isGoldCategory) {
                return marketPrice || '-';
            } else {
                return exchangePrice > 0 ? salePrice : Math.ceil(nft.appraisal_value) || '-';
            }
        } else {
            if (isGoldCategory) {
                return marketPrice || '-';
            } else {
                return Math.ceil(nft.appraisal_value) || '-';
            }
        }

    }
    /**
     * Triggers an email and in-app notification when a transaction fails due to insufficient funds.
     *
     * @param {string} id - The ID of the transaction that failed.
     * @param {string} type - The type of transaction (e.g., "bid").
     */
    notifyInsufficientFunds(id: string, type: string) {
        try {
            this.http.get(`${environment.API_BASE_URL_V3}/transaction-fail-notify?id=${id}&type=${type}`).subscribe({
                error: (error) => {
                    throw error
                }
            })
        } catch (error) {
            this.toastr.error('An error occurred while notifying insufficient funds.');
            console.error(error);
        }
    }

    /**
     * Navigates to the collection detail page when a collection is clicked from the "NFTs in collection" section.
     * @param event The click event.
     * @param collectionAddress The address of the collection.
     */
    navigateToCollectionPage(event: MouseEvent, collectionAddress: string): void {
        event.stopPropagation();
        event.preventDefault();
        this.router.navigate([`/collection-detail/${collectionAddress}`]);
    }

    /**
     * Signs a message using the connected account.
     *
     * @returns {Promise<string>} A promise that resolves to the signature of the message.
     * @throws {Error} If the signing process fails.
     */
    async getSignature() {
        const signature = await signMessage(wagmi_config, {
            message: 'By approving this signature, you agree to the Privacy Policy and User Agreement.',
        })
        return signature
    }
    getDocument() {
        const serviceTypes = ['privacy_policy', 'user_agreement'];
        const sources = serviceTypes.map((type) =>
            this.http.get(`${environment.API_BASE_URL}/file-upload/policy-document`, {
                headers: { 'service_type': type }
            })
        );

        forkJoin(sources).subscribe({
            next: (responses: any[]) => {
                this.docUrls = serviceTypes.reduce((acc, type, index) => {
                    const fileUrl = responses[index]?.data?.file?.[0]?.Url || null;
                    return { ...acc, [`${type}_url`]: fileUrl };
                }, {});
            },
            error: (err: any) => {
                console.error('Error fetching documents:', err);
            }
        });
    }

    /**
     * Checks nft status if the selcted nft is already in open loan offer or not
     * @template C 
     * @param nftId  its like an array ['NftId']
     * @param callBack 
     */
    async checkNftStatus<A, C>(request: A, callBack: (status: any) => C) {
        await this.http.post(`${environment.API_BASE_URL_V3}/nft/open-loan-offer-check`, request).pipe().subscribe({
            next: (response: any) => {
                if (response) callBack(response.data.is_open_loan_offer);
            },
            error: (error: any) => {
                throw error
            }
        })
    }

    /**
     * Updates open loan offer status
     * @param nftId 
     */
    updateOpenLoanOfferStatus(request: any): Observable<any> {
        return this.http.patch(`${environment.API_BASE_URL_V3}/nft/cancel-open-loan-offers`, request)
    }

    /**
     * Handles expiry date
     * @param loan_request_days 
     * @param current_date 
     * @param LOAN_IN_DAYS 
     * @returns  
     */
    handleExpiryDate(loan_request_days: any, current_date: any, LOAN_IN_DAYS: any) {
        return moment(current_date).clone().add(loan_request_days, LOAN_IN_DAYS ? 'days' : 'hours').toISOString()
    }

    /**
     * Process image
     * @param nft 
     * @returns  
     */
    processImage(nft: any) {
        let processImage;
        if (nft.fileType === 'html') {
            processImage = {
                ...nft,
                displayImage: nft.preview_image ? nft.preview_image : nft.secondary_media[0]
            };
        } else {
            processImage = {
                ...nft,
                displayImage: nft.preview_image ? nft.preview_image : nft.primary_media
            };
        }
        return processImage;
    }

    /**
     * Profiles image upload
     * @param {File} file
     * @returns
     */
    profileImageUpload(file: File) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('service_type', 'image');
        return this.http.post(`${environment.API_BASE_URL}/file-upload/document`, formData)
    }

    /**
     * Updates users
     * @param data 
     * @param userId 
     * @returns  
     */
    public updateUsers(data: object, userId: string) {
        return this.http.patch(`${environment.API_BASE_URL_V3}/user?id=${userId}`, data);
    }

    /**
     * Gets profile details
     * @param userId 
     * @returns  
     */
    getProfileDetails(userId: string) {
        return this.http.get(`${environment.API_BASE_URL_V3}/get-user?id=${userId}`);
    }

    /**
     * Gets precious metal values
     * @returns  
     */
    getPreciousMetalValues() {
        return firstValueFrom(this.http.get(`${environment.API_BASE_URL_V3}/get-metal-values`));
    }
    /**
        * Filters attributes
        * @param data
        * @param key
        * @returns
        */
    filterAttributes(filterData: any = [], key: string, mapKey: any) {
        if (Array.isArray(filterData) && filterData.length != 0) {
            const filterValue = filterData.filter((res) => res[mapKey].toLowerCase() == key);
            return filterValue.length != 0 ? filterValue[0]['value'] : '0'
        } else {
            return ''
        }
    }
    /**
     * Handles current market price
     * @param attribute 
     * @param metal_price // Not ; Market Price Consider As Markup Fee
     * @returns  
     */
    handleCurrentMarketPrice(attribute: any, metal_price: any,) {
        const OUNCE_TO_GRAM = 31.1035;
        let markup_fee_percentage = this.filterAttributes(attribute, 'markup fee', 'key')
        let attr_weight = this.filterAttributes(attribute, 'weight', 'key');
        const weight = parseFloat(attr_weight.replace(/g$/i, ''));
        const converted_markup_fee_percentage = markup_fee_percentage ? Number(markup_fee_percentage) : 0
        const price_per_gram = metal_price / OUNCE_TO_GRAM
        const actual_metal_price = price_per_gram * weight
        const markupPercentage = Number(converted_markup_fee_percentage) / 100;
        const mark_up_fee = markupPercentage * actual_metal_price
        return { pricewithgram: actual_metal_price, market_price: mark_up_fee + actual_metal_price }
    };

    /**
     * Handles oauth login
     * @param user here we pass the User Details for the 
     */
    async _handleOauthLogin(user: any) {
        const obj = {
            email: user.email,
            name: user.name,
            apple_signin: false,
            google_signIn: true,
            type: 'login'
        }
        await this.accountService.googleAuth(obj).subscribe((response) => {
            if (response) {
                this.webStorageService.setLocalStorage('regulated', 'true');
                let user: any = response;
                this.webStorageService.setLocalStorage('user', JSON.stringify(user.data));
                this.webStorageService.setLocalStorage('account', JSON.stringify({ walletAddress: user.data.wallet_address, chainId: environment.DEFAULT_CHAIN, walletProvider: "", networkId: Number(environment.DEFAULT_NETWORK), init: false }));
                this.idleService.reset();
                location.reload() //Need to set the user details and other stuffs.
            }
        },
            (error) => {
                this.toastr.error(error?.error?.message || "Something went wrong, try again later.");
            }
        )
    }
    /**
     * Gets image validation
     */
    public get fileExtension(): Array<{ docmentExtension: string[], mediaExtension: string[] }> {
        return [{ "docmentExtension": [...documentFileExtension], 'mediaExtension': [...imageFileExtension, ...mediaFileExtension] }]
    }


    handlePlatformfeeText(platformFee: number = 0, isPercentage: boolean = false, currency?: any, isLastContent: string = '') {
        return isPercentage ? this.handlePercentage(platformFee, isLastContent) : this.handleAmount(platformFee, currency, isLastContent)
    }

    /**
     * Handles fee combiner
     * @param [fee1] 
     * @param [fee2] 
     * @returns  
     */
    handleFeeCombiner(fee1: number = 0, fee2: number = 0) { /// May be this is was vary based on our fee kindly check 
        return (fee1 == 0 || fee2 == 0) ? '' : ' + '
    }
    handlePercentage(value: number = 0, content: string = '') {
        return value == 0 ? '' : `${value}%${content}`
    }
    handleAmount(value: number = 0, currency: any, content: string = '') {
        return value == 0 ? '' : `${value} ${currency}${content}`
    }

    /**
     * Handles nofee applied
     * @param [value] 
     * @param [currency] 
     * @returns  
     */
    handleNofeeApplied(value: number = 0, currency?: any, lastContent: string = '') {
        return value == 0 ? 'No fee applied' : `${value.toFixed(2)} ${currency ? currency : ''} ${lastContent}`
    }

    /**
     * Handles platform fee text
     * @param [value] 
     * @param [custom_text] 
     * @param [not_applied] 
     * @returns  
     */
    handlePlatformFeeText(value: number = 0, not_applied: string = '', custom_text: string = '') {
        return value == 0 ? not_applied : custom_text
    }

    /**
     * Determines whether policy updated user is
     * @param user 
     * @param privacyPolicyModal 
     * @returns true if policy updated user 
     */
    isPolicyUpdatedUser(user: any, privacyPolicyModal: any): boolean {
        if ((user?.is_policy_accepted === false || user?.is_policy_accepted === undefined) && user.email_verified
        ) {
            privacyPolicyModal?.show();
            return true;
        }
        return false;
    }

    /**
     * Updates policy status
     * @param id 
     * @param params 
     * @returns policy status 
     */
    updatePolicyStatus(id: string, params: any): Observable<any> {
        return this.http.patch(`${environment.API_BASE_URL_V3}/user/update-policy-status?id=${id}`, params)
    }

    /**
     * Gets transack link
     * @param data 
     * @param callBack 
     */
    getTransackLink(data: any, callBack: (route: string) => any) {
        let redirect_url: string = ''
        redirect_url = `${environment.TRANSACTION_LINK}=${environment.API_KEY}&walletAddress=${data.wallet_address}&cryptoCurrencyCode=USDC&fiatCurrency=USD&network=polygon&productsAvailed=BUY&email=${data.email}&themeColor=006736&isAutoFillUserData=True`
        callBack(redirect_url)
    }


    getNftUrl(logsDetails: any): string {
        if (logsDetails?.token_id === undefined || logsDetails?.token_id === null) return '';
        const nft = logsDetails?.nft_ids?.[0] || logsDetails
        // const baseUrl = environment.MARKETPLACE_URL;

        const path = nft.lazy_mint
            ? `lazy-mint/${nft._id}`
            : `nft-detail/${nft.collections?.collection_address}/${nft.token_id}`;
        return `${path}`;
    }


    /**
     * Clicks redirect
     * @param data 
     * @param user 
     * @param callBack 
     */
    clickRedirect(data: any, user: any, callBack: (route: string) => any) {
        const parsedData = typeof data.data === 'string' ? JSON.parse(data.data) : data.data;
        const dataValue = data;
        let redirect_url = '';

        const loanDetailMethods = [
            MethodTypes.LOAN_DEFAULT,
            MethodTypes.REQ_LOAN,
            MethodTypes.UPDATE_LOAN,
            MethodTypes.FORECLOSE_LOAN,
            MethodTypes.LOAN_REPAID,
        ];

        const offerMethods = [
            MethodTypes.COUNTER_OFFER,
            MethodTypes.RECOUNT_OFFER,
            MethodTypes.BORROW_RECOUNT_OFFER,
        ];

        const nftDetailMethods = [
            MethodTypes.ITEM_MINTED,
            MethodTypes.PURCHASE_SELL_ORDER,
            MethodTypes.CREATE_ITEM_LOAN_BID,
            MethodTypes.BULK_MINT,
            MethodTypes.CREATE_SELL_ORDER,
            MethodTypes.CANCEL_ITEMBID,
            MethodTypes.CREATE_ITEMBID,
            MethodTypes.ACCEPT_LOAN,
            MethodTypes.BURN_ITEM,
            MethodTypes.CANCEL_LOAN,
            MethodTypes.ACCEPT_ITEMBID,
            MethodTypes.PURCHASE_PARTNER_ITEM,
            MethodTypes.ITEM_TRANSFER,
            MethodTypes.CANCEL_SELL_ORDER,
        ];

        const bulkLoanBidMethods = [
            MethodTypes.CANCEL_ITEM_LOAN_BID,
            MethodTypes.COUNTER_OFFER_OPEN_LOAN_BID,
            MethodTypes.CREATE_BULK_LOAN_BID,
            MethodTypes.ACCEPT_BULK_LOAN_BID,
            MethodTypes.CANCEL_BULK_LOAN_BID,
            MethodTypes.EDIT_BULK_LOAN_BID,
            MethodTypes.ACCEPT_ITEM_LOAN_BID,
        ];

        if (loanDetailMethods.includes(data.method)) {
            const { _id } = parsedData || {};
            if (_id && data?.data?.borrower_id?._id == user?._id) {
                redirect_url = `borrow-detail/${_id}`;
            } else if (_id) {
                redirect_url = `lending-detail/${_id}`
            }
        } else if (offerMethods.includes(data.method)) {
            const loanId = parsedData?.loan_request_id?._id;
            if (loanId) {
                redirect_url = `lending-detail/${loanId}`;
            }
        } else if (data.method === MethodTypes.PARTNER_COL_CREATED) {
            const collectionAddress = parsedData?.collection_address;
            if (collectionAddress) {
                redirect_url = `collection-detail/${collectionAddress}`;
            }
        } else if (nftDetailMethods.includes(data.method)) {
            const collectionAddress = dataValue?.nft_ids?.[0]?.collections?.collection_address;
            const tokenId = dataValue?.nft_ids?.[0]?.token_id;

            if (collectionAddress && tokenId !== undefined) {
                redirect_url = `nft-detail/${collectionAddress}/${tokenId}`;
            }
        } else if (bulkLoanBidMethods.includes(data.method)) {
            redirect_url = `/offer-loans/details/${parsedData._id}`;
        } else {
            console.warn(`Unhandled method type: ${data.method}`);
        }

        callBack(redirect_url);
    }
    /**
     * Gets full name
     * @param data 
     * @param [user] 
     * @returns  
     */
    getFullName(data: any, user?: any) {
        const name = data?.display_name || data?.name || user || '';
        return name?.length >= 15 ? name : '';
    }
}

